import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { TextField, Box, Grid, IconButton } from "@mui/material";
import SyncIcon from "@mui/icons-material/Sync";
import _ from "lodash";
import { connect } from "react-redux";
import {
  addChildren,
  changeFormValues,
  initialState,
  add_UJ_JSON,
} from "../../redux/DynamicForms/dynamicFormsActions";
import SelectBox from "./SelectBox";
import {
  hideLoader,
  navUrl,
  showLoader,
} from "../../redux/Common/commonActions";
import { getRequest } from "../../globalhelper/helper";
import VR2_Forms from "../../pages/VR2_Form_Rendering/displayContainer";
import VendorMaster_Search from "../../pages/Edureka/VendorMaster_Search";
import PurchaseOrder_Search from "../../pages/Edureka/PO_Search";
import ItemMaster_Search from "../../pages/Edureka/ItemMaster_Search";
import InternalPlan_Search from "../../pages/Edureka/InternalPlan_Search";
import Organization_Search from "../Edureka/Organization_Search";
import BillExtract_Search from "../Edureka/BillExtract_Search";
import CostAllocation_Search from "../Edureka/CostAllocation_Search";
import VendorItemInfoSearch from "../Edureka/VendorItemInfoSearch";
import GoodsAndServicesSearch from "../Edureka/GoodsAndServicesSearch";
import ExtendVendorMaster from "../Edureka/ExtendVendorMaster";
import ExtendItemMaster from "../Edureka/ExtendItemMaster";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import Typography from "@mui/material/Typography";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { Set_ORG_ID_CONST } from "../../redux/VR2/vr2Actions";
import { useLocation } from "react-router-dom";
import DraftDocument from "../Edureka/DraftDocument";
import VendorRegistration from "../Edureka/VendorRegistration";

const RecursiveBuilder = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const token = searchParams.get("token");
  const action = searchParams.get("action");
  const orgId = searchParams.get("orgId");
  const docId = searchParams.get("docId");
  const refName = searchParams.get("refName");

  const { UJ_JSON, formValues: reduxFormValues } = useSelector(
    (state) => state.dynamicForms
  );

  const { ORG_ID_CONST } = useSelector((state) => state);

  const [state, setState] = useState({
    recursiveData: [],
    formValues: {},
    screenInfo: null,
  });

  const start = (permission = false) => {
    if (UJ_JSON.length === 0 || permission) {
      dispatch(initialState());
      dispatch(showLoader());
      getRequest(`api/vr2/get_uj_json?module=${localStorage.getItem("module")}`)
        .then((res) => {
          if (res.res.status === "success") {
            dispatch(add_UJ_JSON(res.res.data));
            dispatch(addChildren(null));
          }
        })
        .catch((err) => console.log(err))
        .finally(() => dispatch(hideLoader()));
    }
  };

  useEffect(() => {
    if (ORG_ID_CONST == "") {
      getRequest(`api/edureka/getCompanyAssignedToUser`)
        .then((response) => {
          console.log(response.res.data);
          const responseData = response.res.data;
          dispatch(Set_ORG_ID_CONST(responseData[0].orgid));
        })
        .catch((err) => console.log(err));
    }
    start();
  }, []);

  const updateFormValue = (event, newValue, id, name) => {
    const { value } = newValue || event.target.value || '';
    const newFormValues = { ...state.formValues, [name]: value };
    console.log(event, newValue, id, name);

    dispatch(changeFormValues(newFormValues, id));
    setState((prev) => ({ ...prev, formValues: newFormValues }));

    const screen = _.filter(
      UJ_JSON,
      (item) => item.type === "Change_Screen" && item.value === value
    );

    if (screen.length === 1) {
      console.log("screen", screen);

      setState((prev) => ({
        ...prev,
        screenInfo: {
          redirect: screen[0].nav_to,
          screenName: screen[0].screenName,
          screenAction: screen[0].action,
        },
      }));
    }
  };

  const onBack = () => {

    start(true);
    setState({
      recursiveData: [],
      formValues: {},
      screenInfo: null,
    });
  };

  const { formValues, screenInfo } = state;

  // Screen mappings
  const screenComponents = {
    VR2_Forms: (
      <VR2_Forms
        screenName={screenInfo?.screenName || token || ""}
        screenAction={screenInfo?.screenAction || action || ""}
        onBack={onBack}
      />
    ),
    VendorMaster: <VendorMaster_Search onBack={onBack} />,
    PurchaseOrder: <PurchaseOrder_Search onBack={onBack} />,
    ItemMaster: <ItemMaster_Search onBack={onBack} />,
    InternalPlan: <InternalPlan_Search onBack={onBack} />,
    OrganizationMaster: <Organization_Search onBack={onBack} />,
    BillExtract: <BillExtract_Search onBack={onBack} />,
    CostAllocationMaster: <CostAllocation_Search onBack={onBack} />,
    VendorItemInfo: <VendorItemInfoSearch onBack={onBack} />,
    GoodsAndServicesEntries: <GoodsAndServicesSearch onBack={onBack} />,
    VendorMasterExtend: <ExtendVendorMaster onBack={onBack} />,
    ItemMasterExtend: <ExtendItemMaster onBack={onBack} />,
    DraftDocuments: (
      <DraftDocument
        onBack={onBack}
        screenName={screenInfo?.screenName?.replace("Drafts", "") || ""}
        screenAction={screenInfo?.screenAction || ""}
      />
    ),
    VendorRegistration: (
      <VendorRegistration
        onBack={onBack}
        screenName={screenInfo?.screenName?.replace("Drafts", "") || ""}
        screenAction={screenInfo?.screenAction || ""}
      />
    ),
  };

  if (screenInfo && screenComponents[screenInfo.redirect]) {
    return screenComponents[screenInfo.redirect];
  }

  if (
    (action === "draft" ||
      action === "edit" ||
      action === "approval" ||
      action === "PartialCreate") &&
    orgId &&
    (docId || refName) &&
    token
  ) {
    return (
      <VR2_Forms
        screenName={token || ""}
        screenAction={action || ""}
        refName={refName || null}
        docId={docId || null}
        onBack={() => {
          onBack();
          if (token === "BillExtract") {
            dispatch(navUrl("/inbox", "Inbox"));
            return;
          }
          dispatch(navUrl("/Dynamic_Forms", "Transact"));
        }}
      />
    );
  }

  if (action === "create") {
    return (
      <VR2_Forms
        screenName={token || ""}
        screenAction={action || ""}
        onBack={() => {
          onBack();
          if (token === "BillExtract") {
            dispatch(navUrl("/inbox", "Inbox"));
            return;
          }
          dispatch(navUrl("/Dynamic_Forms", "Transact"));
        }}
      />
    );
  }

  return (
    <Box>
      <Accordion defaultExpanded>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1-content"
          id="panel1-header"
        >
          <Typography variant="h6">Select Task</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Grid container spacing={3}>
            {UJ_JSON.map((obj) => {
              if (!obj.active) return null;

              switch (obj.type) {
                case "input":
                  return (
                    <React.Fragment key={obj.id || obj.serviceKey}>
                      <TextField
                        id="outlined-basic"
                        label={obj.label}
                        variant="outlined"
                        name={obj.serviceKey}
                        sx={obj.inputOptions.css}
                        value={formValues[obj.serviceKey] || ""}
                        onChange={(ev) =>
                          updateFormValue(ev, null, obj.id, obj.serviceKey)
                        }
                        type={obj.inputOptions.type}
                        onBlur={() => dispatch(addChildren(obj.id))}
                      />
                      <br />
                    </React.Fragment>
                  );
                case "select":
                  return (
                    <Grid item xs={1} sm={2} md={3}>
                      <SelectBox
                        {...obj}
                        value={formValues[obj.serviceKey]}
                        onChange={(ev, newValue, id) => {
                          updateFormValue(ev, newValue, id, obj.serviceKey);
                          dispatch(addChildren(obj.id));
                        }}
                      />
                    </Grid>
                  );

                default:
                  return null;
              }
            })}
            <Grid item xs={1}>
              <IconButton color="primary" onClick={() => start(true)}>
                <SyncIcon />
              </IconButton>
            </Grid>
          </Grid>
        </AccordionDetails>
      </Accordion>
    </Box>
  );
};

function mapStateToProps(state) {
  return {
    UJ_JSON: state.dynamicForms.UJ_JSON,
    formValues: state.dynamicForms.formValues,
    ORG_ID_CONST: state.VR2.ORG_ID_CONST,
  };
}

const mapDispatchToProps = (dispatch) => {
  return {
    addChildren: (parent_id) => {
      dispatch(addChildren(parent_id));
    },
    changeFormValues: (key, value) => {
      dispatch(changeFormValues(key, value));
    },
    initialState: (data) => {
      dispatch(initialState(data));
    },
  };
};

export default connect(mapStateToProps, {
  addChildren,
  changeFormValues,
  initialState,
  add_UJ_JSON,
  navUrl,
})(RecursiveBuilder);